import React from 'react'
import { Button, TextField } from '@mui/material';

function UrlUploader({file, onChange, handleModalClose, contextUpdate}) {

    const validateAndUploadFile = () => {
        if (file.trim()) {
            const fileName = file.split('/').pop();

            const fileObject = {
                name: fileName || 'file',
                size: 'Unknown',
                date: new Date().toLocaleDateString(), // Add date
                type: getFileType(fileName),
                data: file,
                fileCat: getFileCategory(fileName)
            };

            const fileCat = getFileCategory(fileName);
            contextUpdate(fileObject, fileCat);
        };
    }
    
      const getFileType = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
          case 'jpg':
          case 'jpeg':
            return 'image/jpeg';
          case 'png':
            return 'image/png';
          case 'gif':
            return 'image/gif';
          case 'mp4':
            return 'video/mp4';
          case 'mov':
            return 'video/quicktime';
          case 'avi':
            return 'video/x-msvideo';
          case 'mpg':
          case 'mpeg':
            return 'video/mpeg';
          case 'pdf':
            return 'application/pdf';
          case 'doc':
          case 'docx':
            return 'application/msword';
          case 'ppt':
          case 'pptx':
            return 'application/vnd.ms-powerpoint';
          case 'xls':
          case 'xlsx':
            return 'application/vnd.ms-excel';
          case 'onetoc':
          case 'onetoc2':
          case 'onetmp':
          case 'onepkg':
            return 'application/onenote';
          case 'gsheet':
            return 'application/vnd.google-apps.spreadsheet';
          case 'gdoc':
            return 'application/vnd.google-apps.document';
          default:
            return 'application/octet-stream';
        }
      };
      
      const getFileCategory = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
          return 'images';
        } else if (['mp4', 'mov', 'avi', 'mpg', 'mpeg'].includes(extension)) {
          return 'videos';
        } else {
          return 'others';
        }
      };


  return (
    <>
          <TextField
              label="Paste URL"
              variant="outlined"
              value={file}
              onChange={onChange}
              fullWidth
              sx={{ marginBottom: "48px" }}
          />
          <div className='d-flex align-items-center justify-content-end' style={{ position: "absolute", bottom: "0px", right: "0px" }}>
              <Button className="secondary-btn" onClick={handleModalClose}> Cancel </Button>
              <Button variant="contained" className="primary-btn ms-3" onClick={() => {
                validateAndUploadFile();
                handleModalClose();
                }} 
                sx={{ boxShadow: "none" }} disabled={file.trim().length === 0}> Add </Button>
          </div>
    </>
  )
}

export default UrlUploader